export const CREATE_RATE_STARTING_POINT = 'new-mmp-rate';
export const CREATE_RATE_ENDING_POINT = 'create-mmp-rate';
export const CREATE_VOUCHER_STARTING_POINT = 'new-mmp-voucher';

export const EDIT_RATE_BULK_STARTING_POINT = 'bulk-rate-edit-button';
export const EDIT_RATE_SINGLE_STARTING_POINT = 'individual-rate-edit-button';
export const SAVE_EDIT_BUTTON = 'save-edit-button';

export const CREATE_RATE_GROUP_STARTING_POINT = 'new-rate-group';
export const CREATE_RATE_GROUP_ENDING_POINT = 'create-new-rate-group';

export const CREATE_VOUCHER_CODE_STARTING_POINT = 'add-voucher-code-mmp';
export const CREATE_VOUCHER_CODE_ENDING_POINT = 'save-voucher-code-mmp';

export const DELETE_VOUCHER_STARTING_POINT = 'delete-voucher-mmp';
export const DELETE_VOUCHER_ENDING_POINT = 'confirm-delete-voucher-mmp';

export const DELETE_RATE_STARTING_POINT = 'delete-rate-mmp';
export const DELETE_RATE_ENDING_POINT = 'confirm-delete-rate-mmp';

export const EDIT_VOUCHER_STARTING_POINT = 'edit-voucher-mmp';
export const EDIT_VOUCHER_ENDING_POINT = 'save-voucher-mmp';
